import { render, staticRenderFns } from "./LinkItem.vue?vue&type=template&id=ffa714fe&scoped=true"
import script from "./LinkItem.vue?vue&type=script&lang=js"
export * from "./LinkItem.vue?vue&type=script&lang=js"
import style0 from "./LinkItem.vue?vue&type=style&index=0&id=ffa714fe&prod&lang=less&scoped=true"
import style1 from "./LinkItem.vue?vue&type=style&index=1&id=ffa714fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa714fe",
  null
  
)

export default component.exports